import { useRef, useState } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';

const testimonials = [
  {
    quote: 'Complimenten voor het team van Direct Uit China. Ze benaderden mij via Instagram met de vraag of zij mijn inkoopkosten konden verlagen. In eerste instantie was ik sceptisch, maar ik besloot hen de opdracht te geven voor bedrukte cadeautasjes en sieradendoosjes. Binnen één dag ontving ik al een offerte die maar liefst 60% goedkoper was dan mijn huidige leverancier. De communicatie was snel en professioneel, en geen enkele vraag was te veel. Ik ben zeer tevreden over de samenwerking en kan Direct Uit China zeker aanbevelen.',
    name: 'Rakesh Kumar',
    title: 'Sehgal Juwelier',
    product: 'Cadeautasjes & sieradendoosjes',
    icon: 'ri-gift-2-line',
  },
  {
    quote: 'Direct Uit China heeft mij geholpen met het sourcen van promotiemateriaal zoals flyers en banners. Het hele proces verliep ontzettend soepel en duidelijk. Ze namen alles uit handen en dachten goed mee. Je merkt echt dat ze hun best doen om het beste resultaat te leveren. Zeker een aanrader.',
    name: 'Samer Pal',
    title: 'Ekdo Events',
    product: 'Promotiemateriaal — flyers & banners',
    icon: 'ri-megaphone-line',
  },
  {
    quote: 'Voor mijn beauty center heeft Direct Uit China mij geholpen met het inkopen van cosmetische producten, machines en tassen. Alles werd professioneel geregeld en het proces was eenvoudig en overzichtelijk. Ik ben erg tevreden met de samenwerking en de service.',
    name: 'Kamal',
    title: 'Kamal Beauty Center',
    product: 'Cosmetica, machines & tassen',
    icon: 'ri-scissors-cut-line',
  },
  {
    quote: 'Direct Uit China heeft mij geholpen met het inkopen van pizzadozen. De communicatie was duidelijk en snel, en het hele traject verliep zonder problemen. Ik ben tevreden met het resultaat en de samenwerking.',
    name: 'Giovanni',
    title: 'Lagaetano',
    product: 'Pizzadozen op maat',
    icon: 'ri-restaurant-line',
  },
  {
    quote: 'Voor mijn zaak heeft Direct Uit China kraft tassen met logo en bedrukte tassen verzorgd. Het proces was makkelijk en goed begeleid. Ze dachten mee en leverden precies wat ik nodig had. Zeker een fijne partij om mee te werken.',
    name: 'Rani',
    title: '55 Bombay Street',
    product: 'Kraft tassen met logo',
    icon: 'ri-shopping-bag-line',
  },
  {
    quote: 'Direct Uit China heeft mij geholpen met het inkopen van cosmetische producten. Alles werd netjes geregeld en het proces was duidelijk en efficiënt. Ik ben tevreden met hoe alles is verlopen.',
    name: 'Munisha',
    title: 'Munisha Beauty Center',
    product: 'Cosmetische producten',
    icon: 'ri-medicine-bottle-line',
  },
  {
    quote: 'Direct Uit China heeft ons geholpen met het inkopen van bedrukte vacuümzakken en grip bags. De communicatie was helder en het proces verliep soepel. We zijn tevreden met de service en het eindresultaat.',
    name: 'Anit Joshi',
    title: 'Holy Cow Dairy',
    product: 'Vacuümzakken & grip bags',
    icon: 'ri-archive-2-line',
  },
];

const resultaten = [
  { value: '30–80%', label: 'Goedkoper dan NL leverancier', sub: 'Direct bij de fabriek inkopen', icon: 'ri-money-euro-circle-line' },
  { value: 'DDP', label: 'All-in levering', sub: 'Transport + invoer + BTW inbegrepen', icon: 'ri-truck-line' },
  { value: '24u', label: 'Reactietijd', sub: 'Prijsvoorstel binnen één werkdag', icon: 'ri-time-line' },
  { value: '100%', label: 'Transparant', sub: 'Geen verborgen kosten ooit', icon: 'ri-shield-check-line' },
];

export default function Testimonials() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  const [active, setActive] = useState(0);

  return (
    <section ref={ref} className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 16 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 border border-[#3B9EE8]/40 bg-[#3B9EE8]/10 rounded-full px-4 py-2 text-[#3B9EE8] text-sm font-600 mb-6"
          >
            <i className="ri-double-quotes-l" />
            Wat klanten zeggen
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="font-heading font-800 text-[#0A1628] text-4xl md:text-5xl"
          >
            Klanten die al
            <br />
            <span className="text-[#3B9EE8]">slimmer inkopen</span>
          </motion.h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-3"
          >
            <div className="flex gap-2 mb-6 flex-wrap">
              {testimonials.map((t, i) => (
                <button
                  key={t.name}
                  onClick={() => setActive(i)}
                  className={`h-2 rounded-full transition-all duration-200 cursor-pointer ${active === i ? 'bg-[#3B9EE8] w-8' : 'bg-[#0A1628]/20 hover:bg-[#0A1628]/40 w-2.5'}`}
                />
              ))}
            </div>
            <div className="bg-[#F7F8FA] rounded-2xl p-8 md:p-10 relative overflow-hidden min-h-[300px] border border-[#0A1628]/5">
              <div className="absolute top-6 right-8 font-heading font-900 text-[#3B9EE8]/10 text-9xl leading-none pointer-events-none select-none">&ldquo;</div>
              <AnimatePresence mode="wait">
                <motion.div
                  key={active}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -16 }}
                  transition={{ duration: 0.35 }}
                >
                  <div className="flex items-center gap-1 mb-5">
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <i key={idx} className="ri-star-fill text-[#3B9EE8] text-sm" />
                    ))}
                    <span className="ml-3 inline-flex items-center gap-1.5 bg-[#3B9EE8]/10 border border-[#3B9EE8]/25 rounded-full px-3 py-0.5">
                      <i className={`${testimonials[active].icon} text-[#3B9EE8] text-xs`} />
                      <span className="text-[#3B9EE8] text-xs font-600">{testimonials[active].product}</span>
                    </span>
                  </div>
                  <blockquote className="text-[#0A1628] text-base md:text-lg leading-relaxed mb-8 font-400">
                    &ldquo;{testimonials[active].quote}&rdquo;
                  </blockquote>
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-full bg-[#3B9EE8]/15 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-user-3-line text-[#3B9EE8] text-2xl" />
                    </div>
                    <div>
                      <div className="font-heading font-700 text-[#0A1628] text-base">{testimonials[active].name}</div>
                      <div className="text-[#0A1628]/50 text-sm">{testimonials[active].title}</div>
                    </div>
                    <div className="ml-auto flex items-center gap-1 text-[#0A1628]/30 text-sm">
                      <span>{active + 1}</span>
                      <span>/</span>
                      <span>{testimonials.length}</span>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            <div className="flex gap-3 mt-4">
              <button
                onClick={() => setActive((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-[#0A1628]/15 hover:border-[#3B9EE8] hover:text-[#3B9EE8] text-[#0A1628]/50 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-base" />
              </button>
              <button
                onClick={() => setActive((prev) => (prev + 1) % testimonials.length)}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-[#0A1628]/15 hover:border-[#3B9EE8] hover:text-[#3B9EE8] text-[#0A1628]/50 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-base" />
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.35 }}
            className="lg:col-span-2 grid grid-cols-2 gap-4"
          >
            {resultaten.map((r, i) => (
              <motion.div
                key={r.label}
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.4 + i * 0.1 }}
                className={`rounded-xl p-5 ${i === 0 ? 'bg-[#0A1628]' : 'bg-[#F7F8FA] border border-[#0A1628]/6'}`}
              >
                <div className={`w-9 h-9 flex items-center justify-center rounded-lg mb-3 ${i === 0 ? 'bg-[#3B9EE8]/20' : 'bg-[#3B9EE8]/10'}`}>
                  <i className={`${r.icon} text-[#3B9EE8] text-base`} />
                </div>
                <div className={`font-heading font-800 text-2xl mb-1 ${i === 0 ? 'text-white' : 'text-[#0A1628]'}`}>{r.value}</div>
                <div className={`text-xs font-600 mb-1 ${i === 0 ? 'text-[#3B9EE8]' : 'text-[#0A1628]'}`}>{r.label}</div>
                <div className={`text-xs leading-snug ${i === 0 ? 'text-white/50' : 'text-[#0A1628]/45'}`}>{r.sub}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
